"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPickerWrapper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StyledSmart_1 = require("../StyledSmart");
exports.SmartPickerWrapper = function (_a) {
    var children = _a.children, rightPane = _a.rightPane;
    return (react_1.default.createElement(StyledSmart_1.StyledSplitPaneContainer, null,
        react_1.default.createElement(StyledSmart_1.StyledLeftPane, null, children),
        react_1.default.createElement(StyledSmart_1.StyledRightPane, null, rightPane)));
};
